import {useDispatch} from 'react-redux'
import useTimeoutFn from 'react-use/lib/useTimeoutFn'

import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity,
  Page
} from '@vio/core/src/analytics/types/Events'

export const useTrackPriceRefreshTimeout = ({
  shouldSkip,
  delayMs,
  page
}: {
  shouldSkip: boolean
  delayMs: number
  page: Page
}) => {
  const dispatch = useDispatch()

  useTimeoutFn(() => {
    if (!shouldSkip) {
      dispatch(
        trackEvent({
          category: Category.System,
          entity: Entity.PriceTimeOut,
          action: Action.Succeeded,
          page
        })
      )
    }
  }, delayMs)
}
